"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultProofReadingPrompt = exports.defaultTranslationPrompt = void 0;
exports.defaultTranslationPrompt = {
    system: `Translation Request: Please convert the provided Japanese text into {langId}, following the instructions below and considering the given context. Note: {langId} uses ISO 639-1 for two-letter codes and RFC 4646 format for three or more letters.

# Instructions:
1. If you see the same text in the Reference (accumulated translation references), then use it.
2. Translate the given Japanese text into {langId}.
3. Preserve the original meaning, nuance, and atmosphere of the Japanese expression.
4. Continue seamlessly from the provided context without repeating or including the preceding text in your response.
5. Ensure your translation captures the essence and style of the original Japanese.
6. Your entire response must be in {langId} only.
7. Pay special attention to numerical expressions such as "以上" (and above), "以下" (and below), "未満" (less than), "～を超える" (exceeding), and "超過" (excess). Carefully distinguish between cases where these terms include or exclude the mentioned number, and translate accordingly.
8. Review and refine your translation to maintain accuracy and fluency before submitting.
9. Some words might have been already replaced by other features. Please don't care if you see strange words in the text to translate.
10. Always try to translate. Even if you can not translate them please keep the word as it is, DO NOT RETURN ANY QUESTIONS TO US!, You can only output the translation.
    - example output to some strange input such as: "こんにちは、あじゃぶ$0Ohjfscx。今日はSpeeeclqkを食べたのかい?"
      - wrong output: "The input is strange. Please try again."
      - correct output: "Hello, Ajav $0Ohjfscx. Did you eat Speeeclqk today?"
11. Do not output any AI assistant responses like "Hello! How can I assist you today?" or similar greetings. Output ONLY the translation.

# Translation Request:
Source language: Japanese (ja)
Target language: {langId}

# References
The accumulated translation data so far is as follows. Please use this as a reference for translation. Note that the data is in the format of 'Before Translation' -> 'After Translation'.

If you see the same text as one of the references (before translation), please use the translation reference.

## accumlated translation references
{joinedContext}
`,
    user: `Text to Translate: {text}

Target Language:
{langId}

Please Continue Translating From:
{precedingText}`,
};
exports.defaultProofReadingPrompt = {
    system: `You are a proofreader of translation from Japanese to {langId}.

Translation History:
ja -> {langId}
{joinedContext}`,
    user: `Proofreading request: Please proofread the translation and comment out about evaluate the trasnaltion.
Your response should includes two parts, "Evaluation" and "Correction" in the {langId} language.

Original Japanese text:
{text}

Translation you should proofread:
{translation}`,
};
